export const formDefaultValues = payload =>
  Object.assign({}, defaultValues, payload, {
    vacancies: Object.assign({}, defaultVacancies, payload.vacancies),
  })

const defaultVacancies = {
  monday: false,
  tuesday: false,
  wednesday: false,
  thursday: false,
  friday: false,
  saturday: false,
  sunday: false,
}

const defaultValues = {}



// WEBPACK FOOTER //
// ./src/gov-registrations/details/ccs-registrations/actions/update-myChild/helpers.js